export default "__VITE_ASSET__DTuR6aBa__"